import { createFileRoute } from "@tanstack/react-router";
import { FundraisingInbox } from "@/components/FundraisingInbox";

function RouteComponent() {
  return (
    <div className="h-[calc(100svh-3.5rem)] overflow-hidden bg-background">
      <FundraisingInbox />
    </div>
  );
}

export const Route = createFileRoute("/_authenticated/fundraising/emails/")({
  component: RouteComponent,
  staticData: { page: "fundraising" },
});
